<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dark color="primary">
        <v-icon class="mr-3">fact_check</v-icon>
        <v-toolbar-title>Revisiones de seguridad pendientes</v-toolbar-title>
        <v-spacer />
        <v-btn icon :loading="loading" @click="fetchPending"><v-icon>refresh</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <v-alert v-if="errorMessage" type="error" outlined>{{ errorMessage }}</v-alert>
        <div v-if="loading" class="text-xs-center pa-5">
          <v-progress-circular indeterminate color="primary" />
        </div>
        <v-alert v-else-if="!revisions.length" type="info" outlined>
          No tienes revisiones pendientes.
        </v-alert>
        <v-layout v-else row wrap>
          <v-flex v-for="revision in revisions" :key="revision.id" xs12 sm6 lg4 class="pa-2">
            <v-card outlined class="fill-height">
              <v-card-title>
                <span class="font-weight-bold">{{ revision.folio || 'Revisión pendiente' }}</span>
                <v-spacer />
                <v-chip small color="warning" text-color="white">En proceso</v-chip>
              </v-card-title>
              <v-card-text>
                <div><strong>Operador:</strong> {{ revision.operador_nombre || revision.guest_name || '-' }}</div>
                <div><strong>Placas:</strong> {{ revision.vehiculo_placas_unidad || revision.vehicle_plate || '-' }}</div>
                <div><strong>Fecha:</strong> {{ revision.fecha || revision.window_date || '-' }}</div>
                <div class="mt-2">
                  <strong>Avance:</strong> {{ answeredCount(revision) }} / {{ totalCount(revision) }} puntos
                </div>
                <v-progress-linear
                  :value="progress(revision)"
                  color="primary"
                  height="8"
                  class="mt-1"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="openRevision(revision)">
                  <v-icon left>edit</v-icon>Continuar revisión
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" persistent scrollable max-width="1500px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Continuar revisión de 17 puntos</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="dialog = false"><v-icon>close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text v-if="loadingDetail" class="text-xs-center pa-6">
          <v-progress-circular indeterminate color="primary" />
        </v-card-text>
        <v-card-text v-else-if="selectedRevision" class="pa-4">
          <revision-diecisiete-puntos
            draft-mode
            :revision-data="selectedRevision"
            :shipping-window-id="resolveShippingWindowId(selectedRevision)"
            :tipo-revision="selectedRevision.tipo_revision || 'entrada'"
            :auth-token="$store.getters.getToken"
            :logo-url="getProfile.logo || ''"
            :operador-nombre-display="selectedRevision.operador_nombre || ''"
            :operador-numero-empleado-display="selectedRevision.operador_numero_empleado || ''"
            @draft-saved="onDraftSaved"
            @submitted="onFinalized"
            @error="onFormError"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import RevisionDiecisietePuntos from '@/components/vigilante/17PointsModal.vue'

export default {
  name: 'SecurityReviewsPending',
  components: { RevisionDiecisietePuntos },
  data() {
    return {
      revisions: [],
      loading: false,
      loadingDetail: false,
      dialog: false,
      selectedRevision: null,
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters(['getProfile'])
  },
  created() {
    this.fetchPending()
  },
  methods: {
    authHeaders() {
      return { 'authorization': 'Token ' + this.$store.getters.getToken }
    },
    async fetchPending() {
      this.loading = true
      this.errorMessage = ''
      try {
        const response = await axios.get(
          'https://empresa-service.intrare.app/shipments/security/revisiones/pendientes/',
          { headers: this.authHeaders() }
        )
        this.revisions = Array.isArray(response.data) ? response.data : (response.data.results || [])
      } catch (error) {
        this.errorMessage = 'No se pudieron cargar las revisiones pendientes.'
      } finally {
        this.loading = false
      }
    },
    answeredCount(revision) {
      if (revision.answered_points !== undefined) return revision.answered_points
      return (revision.respuestas_inspeccion || []).filter(item => item.cumple).length
    },
    totalCount(revision) {
      if (revision.total_points !== undefined) return revision.total_points
      return (revision.respuestas_inspeccion || []).length
    },
    progress(revision) {
      const total = this.totalCount(revision)
      return total ? (this.answeredCount(revision) / total) * 100 : 0
    },
    resolveShippingWindowId(revision) {
      const windowData = revision.shipping_window
      return revision.shipping_window_id || (typeof windowData === 'string' ? windowData : (windowData && (windowData.id || windowData.uuid))) || ''
    },
    async openRevision(revision) {
      this.dialog = true
      this.loadingDetail = true
      try {
        const response = await axios.get(
          'https://empresa-service.intrare.app/shipments/security/revisiones/' + revision.id + '/',
          { headers: this.authHeaders() }
        )
        this.selectedRevision = response.data
      } catch (error) {
        this.dialog = false
        this.errorMessage = 'No se pudo cargar el detalle de la revisión.'
      } finally {
        this.loadingDetail = false
      }
    },
    onDraftSaved() {
      this.dialog = false
      this.selectedRevision = null
      this.fetchPending()
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_message', 'Borrador guardado correctamente')
    },
    onFinalized() {
      this.dialog = false
      this.selectedRevision = null
      this.fetchPending()
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_message', 'Revisión finalizada correctamente')
    },
    onFormError(message) {
      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_color', 'error')
      this.$store.commit('snackbar_change_message', message)
    }
  }
}
</script>
